<template>
  <div id="sub-proceso-impresion">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <v-tabs>
          <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
          <v-tab
            v-for="(tab, index) in tabs"
            :key="index"
            @click="selected(tab)"
            >{{ tab }}</v-tab
          >
          <v-tabs-items>
            <!-- TAB DE IMPRESION -->
            <v-card flat v-if="tabSelect == 'Impresion'">
              <impresion-sub-tab
                :show="true"
                :tipeView="'modifica'"
                :contratoId="contratoId"
              ></impresion-sub-tab>
            </v-card>
            <!-- TAB DE MECANIZADO -->
            <v-card flat v-if="tabSelect == 'Mecanizado'"></v-card>
            <!-- TAB DE DISTRIBUCION -->
            <v-card flat v-if="tabSelect == 'Distribucion'"></v-card>
            <!-- TAB DE ADMINISTRATIVO -->
            <v-card flat v-if="tabSelect == 'Administrativo'"></v-card>
            <!-- TAB DE VISITAS -->
            <v-card flat v-if="tabSelect == 'Visitas'">
              <visita-sub-tab
                :show="true"
                :tipeView="'modifica'"
                :contratoId="contratoId"
              ></visita-sub-tab>
            </v-card>
          </v-tabs-items>
        </v-tabs>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import ImpresionSubTab from "@/modules/impresion/views/proceso/ImpresionSubTab.vue";
import VisitaSubTab from "@/modules/visitas/views/VisitaSubTab.vue";

export default {
  name: "sub-proceso-impresion",

  components: {
    VisitaSubTab,
    ImpresionSubTab,
  },
  props: {
    tabSelected: "",
  },

  data: () => ({
    text: "En construccion",
    proveedor: {},
    tabs: [
      "Impresion",
      "Mecanizado",
      "Distribucion",
      "Administrativo",
      "Visitas",
    ],
    contratoId: "",
    tabSelect: "",
    activeTab: "",
    index: "",
  }),
  mounted() {},
  created() {
    // this.loadSelected();
    // if (
    //   !this.$route.params.contratoId ||
    //   this.$route.params.contratoId == null ||
    //   this.$route.params.contratoId == ""
    // ) {
    //   this.contratoId = this.$store.getters.contratoStored;
    // } else {
    //   this.contratoId = this.$route.params.contratoId;
    //   this.$store.commit("contrato_state", this.contratoId);
    // }
  },
  methods: {
    loadSelected() {
      // this.tabSelected = this.$store.getters.tabSelectedStored;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
  },
};
</script>
